import React, { useState, useRef, useEffect } from 'react';
import {
  ListItem,
  ListItemText,
  IconButton,
  Checkbox,
  Box,
  useMediaQuery,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import styles from '../styles/Checklist.module.css';

const ChecklistItem = ({
  item,
  onToggle,
  onOpenDetails,
  onDelete,
  showCategory,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [isSlided, setIsSlided] = useState(false);
  const itemRef = useRef(null);
  const isDesktop = useMediaQuery('(min-width:600px)');

  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;

    if (isLeftSwipe) {
      setIsSlided(true);
    } else {
      setIsSlided(false);
    }
  };

  // 点击其他地方时关闭滑动状态
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (itemRef.current && !itemRef.current.contains(event.target)) {
        setIsSlided(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleItemClick = (e) => {
    if (e.target.tagName === 'INPUT' || e.target.closest('.MuiCheckbox-root')) {
      return;
    }
    onOpenDetails(item);
  };

  const formatDueDate = (date) => {
    const dueDate = new Date(date);
    const isPastDue = dueDate < new Date();
    const formattedDate = dueDate.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });

    if (isPastDue) {
      return (
        <span>
          <span className={styles.pastDue}>Past Due</span>
          <span className={styles.separator}>•</span>
          <span>{`Due ${formattedDate}`}</span>
        </span>
      );
    }
    return `Due ${formattedDate}`;
  };

  return (
    <div
      ref={itemRef}
      className={styles.listItemWrapper}
      onTouchStart={!isDesktop ? onTouchStart : undefined}
      onTouchMove={!isDesktop ? onTouchMove : undefined}
      onTouchEnd={!isDesktop ? onTouchEnd : undefined}
    >
      <ListItem
        className={`${styles.listItem} ${
          isHovered && isDesktop ? styles.hovered : ''
        } ${isSlided ? styles.slided : ''}`}
        onMouseEnter={() => isDesktop && setIsHovered(true)}
        onMouseLeave={() => isDesktop && setIsHovered(false)}
        onClick={handleItemClick}
        sx={{ cursor: 'pointer' }}
      >
        <Checkbox
          edge="start"
          checked={item.isDone}
          onChange={() => onToggle(item)}
        />
        <ListItemText
          primary={
            <span>
              {item.taskItemName}
              {showCategory && (
                <strong className={styles.category}> ({item.category})</strong>
              )}
            </span>
          }
          secondary={formatDueDate(item.dueBy)}
          sx={{
            textDecoration: item.isDone ? 'line-through' : 'none',
            '& .MuiListItemText-secondary': {
              display: 'flex',
              alignItems: 'center',
            },
          }}
        />
        {isDesktop && (
          <Box className={styles.actionButtons}>
            {isHovered ? (
              <>
                <IconButton
                  edge="end"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(item._id);
                  }}
                  className={styles.deleteButton}
                >
                  <DeleteIcon />
                </IconButton>
                <span className={styles.viewText}>View details</span>
              </>
            ) : (
              <IconButton
                edge="end"
                onClick={() => onOpenDetails(item)}
                className={styles.iconButton}
              >
                <MoreHorizIcon />
              </IconButton>
            )}
          </Box>
        )}
      </ListItem>
      {!isDesktop && (
        <div
          className={`${styles.slideDeleteButton} ${
            isSlided ? styles.show : ''
          }`}
        >
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onDelete(item._id);
            }}
            className={styles.mobileDeleteButton}
          >
            <DeleteIcon />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default ChecklistItem;
